import React from 'react';
import './CategoryPage.css';

function SchoolStudentCategory({ onNavigate, onClose }) {
  return (
    <div className="category-page-container">
      <div className="category-page-header">
        <button onClick={onClose} className="back-button">
          ← Back to Dashboard
        </button>
        <div className="category-page-title">
          <span className="category-page-icon">🏫</span>
          <h1>School & Student Management</h1>
        </div>
      </div>

      <div className="category-page-content">
        <div className="action-grid">
          <button className="action-card card-orange" onClick={() => onNavigate('addSchool')}>
            <span className="action-icon">🏫</span>
            <span className="action-text">Add New School</span>
          </button>

          {/* ✅ ADD THIS NEW BUTTON HERE */}
          <button className="action-card card-yellow" onClick={() => onNavigate('addProspect')}>
            <span className="action-icon">📅</span>
            <span className="action-text">Add Demo</span>
          </button>

          <button className="action-card card-blue" onClick={() => onNavigate('addStudent')}>
            <span className="action-icon">👤</span>
            <span className="action-text">Add New Student</span>
          </button>

          <button className="action-card card-purple" onClick={() => onNavigate('viewStudents')}>
            <span className="action-icon">📋</span>
            <span className="action-text">View All Students</span>
          </button>

          <button className="action-card card-green" onClick={() => onNavigate('viewSchools')}>
            <span className="action-icon">🏫</span>
            <span className="action-text">View/Edit All Schools</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default SchoolStudentCategory;